import { useCallback, useEffect, useState } from 'react';
import type { GroupByMode } from './nestedGroup';

const STORAGE_KEY = 'med738.followUps.groupBy';
const DEFAULT_MODE: GroupByMode = 'session';

/**
 * Persist the CM's chosen Group-by mode (Session vs Group) across sessions
 * (AC16b). Defaults to "Session" on first load.
 */
export function useGroupByPreference(): [GroupByMode, (mode: GroupByMode) => void] {
  const [mode, setMode] = useState<GroupByMode>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'session' || stored === 'group') return stored;
    } catch {
      /* ignore storage errors (SSR, privacy mode) */
    }
    return DEFAULT_MODE;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* ignore */
    }
  }, [mode]);

  const update = useCallback((next: GroupByMode) => setMode(next), []);

  return [mode, update];
}
